import { useLanguage } from "../../../../context/LanguageContext";
import { Button } from "../../../../components/ui/button";
import { ArrowUpDown, Edit2, PlusCircle, Trash2 } from "lucide-react";
import { DataTable } from "../../../../components/DataTable";
import { useAuth } from "../../../../context/AuthContext";
import { BaseUrlApi, ErrorMessage } from "../../../../lib/api";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Spin } from "antd";
import { Badge } from "../../../../components/ui/badge";
import MainButton from "../../../../components/MainButton";
import DialogDelete from "../../../../components/common/DialogDelete";
import axios from "axios";
import { DateFormate } from "../../../../lib/utils";
import PaymentMethodDialog from './PaymentMethodDialog';

const PaymentMethodsPage = () => {
  const { language } = useLanguage();

  const [open, setOpen] = useState(false);
  const [methodData, setMethodData] = useState({});
  const [errors, setErrors] = useState({});

  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMethods = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/payment-methods`);
      setMethods(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") toast("Error", { description: result });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMethods();
  }, []);

  const handleTransaction = async (formData) => {
    setLoading(true);
    setErrors({});
    try {
      if (methodData?.id) {
        await axios.put(
          `${BaseUrlApi}/payment-methods/${methodData?.id}`,
          formData
        );
        toast("Payment Method saved", { status: "success" });
      } else {
        await axios.post(`${BaseUrlApi}/payment-methods`, formData);
        toast("payment Method added", { status: "success" });
      }
      await fetchMethods();
      setOpen(false);
    } catch (error) {
      const msg = ErrorMessage(error);
      if (typeof msg === "string")
        toast("Error", { description: msg, status: "error" });
      setErrors(msg);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Name
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      accessorKey: "description",
      header: "Description",
    },
    {
      accessorKey: "created_at",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Created At
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ getValue }) => DateFormate(getValue()),
    },
    {
      accessorKey: "status",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Status
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ getValue }) => {
        const isActive = getValue();
        return (
          <Badge variant={isActive ? "default" : "destructive"}>
            {isActive ? "Active" : "Inactive"}
          </Badge>
        );
      },
    },
    {
      accessorKey: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              setOpen(true);
              setMethodData(row.original);
            }}
          >
            <Edit2 />
          </Button>
          <DialogDelete
            apiLink={`/payment-methods/${row.original?.id}`}
            onSuccess={fetchMethods}
            itemTitle={row.original?.name}
            name={"Payment Method"}
          >
            <Button variant="ghost" size="icon">
              <Trash2 />
            </Button>
          </DialogDelete>
        </div>
      ),
    },
  ];
  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="flex items-center gap-2 justify-between flex-wrap">
        <h1 className="text-2xl font-bold">Payment Methods</h1>
        <MainButton
          Icon={PlusCircle}
          title={"Add Payment Method"}
          onClick={() => {
            setMethodData({});
            setOpen(true);
          }}
        />
        <PaymentMethodDialog
          open={open}
          onOpenChange={setOpen}
          data={methodData}
          saving={loading}
          onSave={handleTransaction}
          errors={errors}
        />
      </div>
      {loading ? (
        <div className="flex items-center justify-center h-40">
          <Spin size="large" />
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={methods}
          title={"payment method by name"}
          filterNames={["name"]}
        />
      )}
    </div>
  );
};

export default PaymentMethodsPage;
